module.exports = __webpack_public_path__ + "img/custom-software.8f1b5110.png";